module.exports = __webpack_public_path__ + "PalashParate-d1d0f3cb.webp";